import React from 'react';
import i18next from 'i18n';
import useItemContext from '@/hooks/useItemContext';
import { getRelatedItemsFn } from '@/queries/item';
import { useQuery } from '@tanstack/react-query';
import ItemsCarousel from '../ProductsCarousel';

const ProductRelated = () => {
    const { item } = useItemContext();
    const { data } = useQuery({
        queryKey: ['getRelatedItemsFn', item?.id],
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        queryFn: () => getRelatedItemsFn(item?.id!),
        enabled: item !== undefined
    });
    if (!data || data.length === 0) {
        return null;
    }
    return (
        <ItemsCarousel
            title={i18next.t('carousel.related')}
            items={data} />
    );
};

export default ProductRelated;
